// extracted by css-extract-rspack-plugin
export default {"container":"container-m5Fl3g","banner":"banner-caYMQR","message":"message-kAOi4b"};